import { render, staticRenderFns } from "./ChoiceBubble.vue?vue&type=template&id=2dba917a&scoped=true&"
import script from "./ChoiceBubble.vue?vue&type=script&lang=js&"
export * from "./ChoiceBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceBubble.vue?vue&type=style&index=0&id=2dba917a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba917a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VExpandXTransition,VRow})
